import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import ItemTabsWidget, { richTextConfigItems, tabSettingsDefault } from '../item/LandingPageTabs/ItemTabsWidget';
export const tabConfigItems = {
    about: {
        name: 'Show About Tab',
        description: 'Show the item info on the card',
        tokenKey: 'courseAboutLabel',
    },
    instructors: {
        name: 'Show Instructors Tab',
        description: 'Show the instructors info on the card',
        tokenKey: 'instructorsTabLabel',
    },
    outline: {
        name: 'Show Outline Tab',
        description: 'Show the outline info on the card',
        tokenKey: 'courseOutlineLabel',
    },
    ...richTextConfigItems,
};
const CourseTabsWidget = ({ courseID, tabSettings, progressBarColor, }) => (_jsx(ItemTabsWidget, { itemType: "course", itemID: courseID, tabConfigItems: tabConfigItems, tabSettings: tabSettings, progressBarColor: progressBarColor }));
CourseTabsWidget.meta = {
    group: 'design',
    name: 'Course Tabs',
    description: 'Display course information in a set of tabs.',
    props: [
        {
            key: 'courseID',
            name: 'Course',
            type: 'course',
            description: 'The course to display information about',
        },
        {
            key: 'tabSettings',
            name: 'Tabs',
            type: 'courseTabsConfig',
            description: 'Show and hide individual tabs as well as control tab order',
            items: tabConfigItems,
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'CourseTabs',
        props: {
            courseID: '@courseID',
            limitToPageWidth: true,
            tabSettings: tabSettingsDefault,
        },
    },
};
export default observer(CourseTabsWidget);
//# sourceMappingURL=CourseTabsWidget.js.map